var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("generic-modal", {
    ref: "modal",
    attrs: { id: "document-rename-modal", "modal-dialog-scrollable": false },
    on: { show: _vm.handleModalShow, hidden: _vm.handleModalHidden },
    scopedSlots: _vm._u([
      {
        key: "header",
        fn: function () {
          return [
            _c("h5", { staticClass: "modal-title bold" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$t("documents.renameDocument")) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "body",
        fn: function () {
          return [
            _c("material-input", {
              attrs: {
                value: _vm.oldDocumentName,
                disabled: "",
                label: _vm.$t("documents.oldName"),
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-group-material-flex" },
              [
                _c("material-input", {
                  staticClass: "form-group-material-grow",
                  attrs: {
                    "validator-context": _vm.$v,
                    label: _vm.$t("documents.newName"),
                  },
                  model: {
                    value: _vm.newDocumentName,
                    callback: function ($$v) {
                      _vm.newDocumentName = $$v
                    },
                    expression: "newDocumentName",
                  },
                }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "material-input form-group-material w-auto" },
                  [
                    _c(
                      "span",
                      {
                        staticClass:
                          "material-input material-input form app-form form-control form-control-filled",
                        attrs: { disabled: "" },
                      },
                      [
                        _c(
                          "span",
                          { staticClass: "document-rename-extension" },
                          [_vm._v(_vm._s(_vm.fileExtension))]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("span", { staticClass: "bar" }),
                  ]
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "simple-button",
              {
                attrs: {
                  type: "primary",
                  loading: _vm.editingDocument,
                  "loading-succeeded": !_vm.editingDocument,
                  disabled: _vm.$v.$invalid,
                },
                on: { click: _vm.handleRenameDocument },
              },
              [
                _vm._v(
                  "\n      " + _vm._s(_vm.$t("global.words.save")) + "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }